import styled from "styled-components";

const Title = styled.h2`
    font-size: 32px;
    font-weight: bold;
    color: ${(props) => props.color || "#fff"};
    text-transform: uppercase;
    margin-bottom: 10px;

    @media (min-width: 996px) {
        font-size: 60px
    }
`;

const Sectionpd = styled.section`
    padding: 40px 0;
    @media (min-width: 996px) {
        padding: 60px 0;
    }
    @media (min-width: 1280px) {
        padding: 80px 0;
    }

    @media (min-width: 1440px) {
        padding: 100px 0;
    }
`

const Paragrafo = styled.p`
    font-size: 16px;
    font-weight: 200;
    color: ${(props) => props.color || "#fff"};
    @media (min-width: 996px) {
        font-size: 16px
    }
`;

export { Title, Paragrafo, Sectionpd };

